import { mapDTO } from '@twistezo/ts-dto-mapper'
import { omit } from 'lodash'

import { fieldsToOmit } from 'providers/tanstack-query/utils'

import type { Schema } from 'features/inventory/domain/forms/RichPlacementsForm/sections/InterstitialForm/schema'
import type { UpdateDomainInterstitialMutationVariables } from 'gql/graphql'
import type { Ability } from 'providers/casl'

type From = Schema
type To = Omit<UpdateDomainInterstitialMutationVariables['input'], 'domainId'>

export const toDTO = (from: From, ability: Ability): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      availability,
      customVariableName,
      customVariableTriggerEnabled,
      customVariableValue,
      enabled,
      matchType,
      path,
      pathTriggerEnabled,
    }: From): To => {
      const constantFields: Omit<To, 'availability'> = {
        customVariableTriggerEnabled,
        ...(customVariableTriggerEnabled ? { customVariableName, customVariableValue } : {}),
        enabled,
        pathTriggerEnabled,
        ...(pathTriggerEnabled ? { matchType, path } : {}),
      }

      const variableFields: Pick<To, 'availability'> = {
        availability,
      }

      return {
        ...constantFields,
        ...omit(
          variableFields,
          fieldsToOmit<To>({
            availability: ability.cannot(
              'update',
              'DomainRichPlacementsFeature-interstitialEmployeeSettings',
            ),
          }),
        ),
      }
    },
  )
